import React, { useState } from 'react';

const faqItemsFr = [
  {
    question: "Où se trouve une parapharmacie à Ain Aouda ?",
    answer: "La Parapharmacie El Hiba se trouve à quartier Al Wahda avant quartier Atlas, Ain Aouda, dans la région de Rabat-Salé-Kénitra. Ou tapez simplement Pharmacie El Hiba Ain Aouda sur Google maps."
  },
  {
    question: "Quelle est l'adresse de la Parapharmacie El Hiba ?",
    answer: "Notre adresse exacte est : lot 551 ; quartier Al Wahda. En partant sur la route de Rommani notre parapharmacie se situe avant quartier Atlas et en parallèle avec Sidi Larbi à 100 m de boulevard Mohamed VI. Vous pouvez aussi nous localiser directement sur Google Maps en écrivant Pharmacie El Hiba Ain Aouda."
  },
  {
    question: "Y a-t-il une parapharmacie à Ain El Aouda ouverte maintenant ?",
    answer: "Pour savoir si nous sommes ouverts en ce moment, le mieux est de consulter notre fiche sur Google ou de nous appeler directement. Nos horaires sont : Du Lundi au Vendredi de 00:00 à 24:00 (24/24), le Samedi de 00:00 à 14:00, et le Dimanche est fermé."
  },
  {
    question: "Quelle est la pharmacie la plus proche d'Ain Aouda centre ?",
    answer: "La Parapharmacie El Hiba Ain Aouda est située à Aïn El Aouda même, à seulement 3 minutes de la station Shell. N'hésitez pas à consulter Google Maps pour connaître la distance exacte depuis votre position."
  },
  {
    question: "Comment aller à la Parapharmacie El Hiba depuis Témara ?",
    answer: "Aïn Aouda est accessible depuis Témara en bus (ligne 303) ou en grand taxi. Une fois sur place, vous pouvez suivre l'itinéraire via Google Maps jusqu'à notre officine en tapant PHARMACIE EL HIBA AIN AOUDA."
  },
  {
    question: "Y a-t-il une parapharmacie près de chez moi à Aïn Aouda ?",
    answer: "La Parapharmacie El Hiba dessert Aïn Aouda et ses quartiers environnants. Contactez-nous au 0708786202 avec votre position pour confirmer la distance depuis chez vous."
  },
  {
    question: "Quels sont les horaires d'ouverture de la Parapharmacie El Hiba ?",
    answer: "Nos horaires sont : Lundi-Vendredi : 24h/24, Samedi : 00h00 à 14h00, Dimanche : fermé. Ils sont également disponibles sur notre fiche Google Business."
  },
  {
    question: "La pharmacie El Hiba est-elle ouverte le dimanche ?",
    answer: "Pour connaître notre ouverture le dimanche, consultez nos horaires à jour sur notre fiche Google ou contactez-nous directement."
  },
  {
    question: "Quel est le numéro de téléphone de la Parapharmacie El Hiba ?",
    answer: "Notre numéro est 0708786202. Vous pouvez aussi nous joindre via notre fiche Google."
  },
  {
    question: "Peut-on réserver un produit par téléphone avant de passer ?",
    answer: "Oui, vous pouvez nous appeler pour vérifier la disponibilité d'un produit avant de vous déplacer ou demander une livraison pour les produits de la parapharmacie."
  },
  {
    question: "Quels types de produits propose la Parapharmacie El Hiba ?",
    answer: "Nous proposons une large gamme de produits dermocosmétiques, de soins capillaires, d'hygiène, de compléments alimentaires, ainsi que des produits de soin pour bébés et mamans."
  },
  {
    question: "Quels produits de soin pour le visage proposez-vous ?",
    answer: "Nous proposons des nettoyants, des nettoyants doux, des crèmes hydratantes, des sérums ciblés, des crèmes anti-taches, des soins anti-âge et des protections solaires adaptées à chaque type de peau."
  },
  {
    question: "Avez-vous des soins spécifiques pour la peau acnéique ou à imperfections ?",
    answer: "Oui, nous proposons des gammes spécialisées pour les peaux à tendance acnéique (gels nettoyants purifiants, soins matifiants, gels correcteurs) issus de marques dermatologiques reconnues."
  },
  {
    question: "Proposez-vous des produits anti-taches et éclaircissants ?",
    answer: "Oui, nous disposons de sérums et de crèmes dépigmentantes formulés pour réduire l'hyperpigmentation et unifier le teint."
  },
  {
    question: "Quels produits solaires sont disponibles dans votre parapharmacie ?",
    answer: "Nous proposons des écrans solaires minéraux et fluides, teintés ou invisibles, adaptés aux peaux sensibles, grasses, sèches ou sujettes aux taches."
  },
  {
    question: "Proposez-vous des soins pour le corps et l'hydratation de la peau sèche ?",
    answer: "Oui, nous disposons de laits corporels, de baumes réparateurs, d'huiles hydratantes et de soins relipidants pour peaux très sèches ou à tendance atopique."
  },
  {
    question: "Quels types de soins capillaires proposez-vous ?",
    answer: "Notre sélection comprend des shampooings traitants, des masques, des sérums anti-chute, des soins fortifiants et des huiles nourissantes pour tous types de cheveux."
  },
  {
    question: "Avez-vous des compléments alimentaires en stock ?",
    answer: "Oui, nous proposons une sélection de compléments alimentaires pour les cheveux et ongles, la fatigue, le tonus, la digestion et le système immunitaire."
  },
  {
    question: "Proposez-vous des produits d'hygiène quotidienne ?",
    answer: "Oui, nous proposons des gels douche surgras, des soins d'hygiène intime, des déodorants et des produits de soin bucco-dentaire."
  },
  {
    question: "Proposez-vous des produits pour bébé et maman ?",
    answer: "Oui, nous avons une gamme dédiée comprenant des laits nettoyants, des liniments, des soins anti-rougeurs, des crèmes vergetures et des soins d'allaitement."
  },
  {
    question: "Où acheter des produits SVR à Aïn Aouda ?",
    answer: "La marque SVR est disponible à la Parapharmacie El Hiba, à Aïn Aouda. Contactez-nous pour confirmer la disponibilité de la référence précise que vous cherchez."
  },
  {
    question: "La parapharmacie vend-elle la marque Eucerin ?",
    answer: "Oui, Eucerin fait partie des marques dermocosmétiques disponibles chez nous."
  },
  {
    question: "Où trouver une crème solaire Heliocare près d'Aïn Aouda ?",
    answer: "La gamme Heliocare est disponible à la Parapharmacie El Hiba à Aïn Aouda."
  },
  {
    question: "Avez-vous des produits Isdin en stock ?",
    answer: "Isdin fait partie de nos marques dermocosmétiques ; contactez-nous pour confirmer la disponibilité du produit précis que vous recherchez."
  },
  {
    question: "Quelle est la différence entre Isispharma et les autres marques dermocosmétiques ?",
    answer: "Chaque marque dermocosmétique a ses propres formulations et indications. Notre pharmacienne peut vous orienter selon votre type de peau."
  },
  {
    question: "Proposez-vous la livraison à domicile à Aïn Aouda ?",
    answer: "Oui, la livraison à domicile est disponible sur Aïn Aouda et ses environs pour l'ensemble des produits de parapharmacie."
  },
  {
    question: "Livrez-vous en dehors d'Aïn Aouda et partout au Maroc ?",
    answer: "Oui, nous assurons la livraison de vos commandes de parapharmacie partout au Maroc."
  },
  {
    question: "Quels sont les délais et moyens de paiement pour les livraisons ?",
    answer: "Les livraisons locales sont généralement très rapides (1 – 2 jours) et paiement à la livraison."
  },
  {
    question: "Avez-vous des produits de soin spécifiques pour homme ?",
    answer: "Oui, une sélection de produits de soin adaptés aux hommes (visage, cheveux) est disponible chez nous avec des idées cadeaux prêtes à être livrées à Aïn El Aouda ou partout au Maroc."
  },
  {
    question: "Quels produits conviennent à une adolescente qui a de l'acné ?",
    answer: "Nous proposons des produits dermocosmétiques adaptés aux peaux à imperfections. Notre pharmacienne peut recommander une routine adaptée à l'âge et au type de peau lors d'une visite ou avant de passer votre commande en ligne prête à être livrée à Aïn El Aouda ou partout au Maroc."
  },
  {
    question: "Avez-vous des idées de cadeaux beauté pour une femme ?",
    answer: "Oui, nous proposons des sélections de produits dermocosmétiques adaptées pour offrir, pour toutes les occasions."
  },
  {
    question: "Proposez-vous des coffrets cadeaux dermocosmétiques ?",
    answer: "Nous pouvons vous orienter vers une sélection de produits à offrir ; passez nous voir ou contactez-nous pour connaître les options disponibles actuellement."
  },
  {
    question: "Est-il possible d'obtenir un conseil personnalisé avant d'acheter ?",
    answer: "Absolument. Notre pharmacienne est à votre disposition sur place ou par téléphone/WhatsApp pour analyser les besoins de votre peau et vous proposer une routine sur-mesure."
  },
  {
    question: "Quelle est la meilleure parapharmacie à Aïn Aouda pour un conseil personnalisé ?",
    answer: "Nous ne pouvons pas juger objectivement qui est « la meilleure », mais nous pouvons affirmer que la Parapharmacie El Hiba propose une routine de soin personnalisée établie gratuitement par notre pharmacienne avant chaque achat."
  },
  {
    question: "Les produits vendus sont-ils garantis authentiques ?",
    answer: "Nous proposons des marques reconnues telles que Isispharma, SVR, ACM, A-Derma, Avène, Bioderma, CeraVe, Ducray, Eucerin, Isdin, Kérastase, La Roche-Posay, Neutrogena, Nuxe, Uriage, Vichy, Galbi Dermatologie, Capila. Pour toute question sur l'authenticité d'un produit précis, n'hésitez pas à nous contacter directement."
  }
];

const faqItemsAr = [
  {
    question: 'أين توجد بارافارماسي في عين عودة؟',
    answer: 'توجد Parapharmacie El Hiba في حي الوحدة ، عين عودة، المغرب. وهي موجهة للأشخاص الذين يبحثون عن منتجات البارافارماسي والعناية بالبشرة والوجه والجسم والشعر، بالإضافة إلى منتجات النظافة والجمال والأم والطفل والحماية من الشمس. موقعها في عين عودة يجعلها خياراً محلياً للأشخاص الذين يبحثون عن parapharmacie à Ain Aouda أو بارافارماسي بعين عودة.'
  },
  {
    question: 'ما هي المنتجات التي يمكن العثور عليها في بارافارماسي بعين عودة؟',
    answer: 'يمكن العثور في Parapharmacie El Hiba على مجموعة متنوعة من منتجات العناية والجمال والرفاهية، حسب التوفر، مثل منتجات العناية بالوجه والبشرة والجسم والشعر، منتجات النظافة، الحماية من الشمس، ومنتجات الأم والطفل. وتناسب هذه الفئة من المنتجات الأشخاص الذين يبحثون عن produits de parapharmacie à Ain Aouda للاستعمال اليومي والعناية الشخصية.'
  },
  {
    question: 'أين أجد منتجات العناية بالبشرة والوجه في عين عودة؟',
    answer: 'للبحث عن منتجات العناية بالبشرة والوجه في عين عودة، يمكن التوجه إلى Parapharmacie El Hiba في Lot 551، عين عودة. وتشمل فئة العناية بالوجه عادةً منتجات التنظيف والترطيب والعناية بالبشرة والحماية اليومية من العوامل الخارجية، حسب العلامات والمنتجات المتوفرة. يمكن الاستفسار مباشرة عن توفر المنتج أو النوع المطلوب.'
  },
  {
    question: 'أين أجد منتجات العناية بالشعر في عين عودة؟',
    answer: 'توفر Parapharmacie El Hiba في عين عودة فئة من منتجات العناية بالشعر وفروة الرأس حسب المنتجات المتاحة. ويمكن البحث عن منتجات الشعر ضمن مستحضرات البارافارماسي والعناية الشخصية، واختيار المنتج وفق نوع الشعر واحتياجات العناية اليومية. لمن يبحث عن soins cheveux Ain Aouda أو produits capillaires à Ain Aouda، يمكن الاستفسار عن المنتج المطلوب وتوفره.'
  },
  {
    question: 'أين يمكن شراء واقي الشمس في عين عودة؟',
    answer: 'يمكن البحث عن واقيات الشمس ومنتجات الحماية من الأشعة فوق البنفسجية في Parapharmacie El Hiba بعين عودة. وتختلف تركيبات وملمس منتجات الحماية الشمسية حسب نوع البشرة واحتياجات الاستخدام، مثل البشرة الدهنية أو الجافة أو الحساسة. يمكن الاستفسار عن الأنواع المتوفرة واختيار المنتج المناسب من بين المنتجات المتاحة في البارافارماسي.'
  },
  {
    question: 'هل توجد بارافارماسي قريبة مني في عين عودة؟',
    answer: 'إذا كنت تبحث عن بارافارماسي قريبة منك في عين عودة، فإن Parapharmacie El Hiba تقع في Lot 551، عين عودة، المغرب. ويُنصح باستخدام اسم المؤسسة والعنوان في الخرائط للتحقق من المسافة الفعلية انطلاقاً من موقعك. ويمكن أن تختلف نتائج البحث عن «بارافارماسي بالقرب مني» حسب الموقع الجغرافي الدقيق للمستخدم.'
  },
  {
    question: 'هل يمكنني السؤال عن توفر منتج معين في Parapharmacie El Hiba؟',
    answer: 'نعم، عند البحث عن منتج محدد في Parapharmacie El Hiba في عين عودة، من المفيد الاستفسار عن الاسم الدقيق للمنتج أو العلامة أو الحجم لمعرفة مدى توفره. وقد تختلف المخزونات من منتج إلى آخر، لذلك لا ينبغي افتراض أن كل منتج موجود بشكل دائم. هذه الطريقة مفيدة خصوصاً عند البحث عن produit de parapharmacie disponible à Ain Aouda.'
  },
  {
    question: 'أين أجد مستحضرات التجميل والعناية اليومية في عين عودة؟',
    answer: 'توفر Parapharmacie El Hiba في عين عودة فئات مرتبطة بالعناية الشخصية والجمال والنظافة والعناية بالبشرة والشعر، حسب المنتجات المتاحة. ويمكن للأشخاص الذين يبحثون عن مستحضرات التجميل في عين عودة أو produits beauté Ain Aouda الاستفسار عن الفئة أو المنتج الذي يبحثون عنه. الهدف هو تسهيل العثور على منتجات العناية اليومية من مكان بارافارماسي محلي.'
  },
  {
    question: 'كيف أجد Parapharmacie El Hiba عند البحث عن بارافارماسي في Ain Aouda؟',
    answer: 'عند البحث في Google أو Google Maps عن parapharmacie Ain Aouda أو بارافارماسي عين عودة، استخدم اسم Pharmacie El Hiba ain aouda مع الموقع حي الوحدة، Ain El Aouda، Maroc. يساعد الجمع بين اسم المؤسسة والمدينة والعنوان على تضييق نتائج البحث المحلية والعثور على الموقع الصحيح.'
  }
];

const FaqColumn = ({ lang, items }) => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleItem = (index) => {
    setOpenIndex(prev => (prev === index ? -1 : index));
  };

  const isAr = lang === 'ar';

  return (
    <div className="faq-column" dir={isAr ? 'rtl' : 'ltr'} lang={isAr ? 'ar' : 'fr'}>
      <div className="faq-column-header">
        <span className="faq-lang-badge">{isAr ? 'عربي' : '🇫🇷'}</span>
        <div>
          <h3>{isAr ? 'بالعربية' : 'En Français'}</h3>
          <p>
            {isAr
              ? 'اكتشف هنا إجابات على الأسئلة الأكثر شيوعًا حول El Hiba Para.'
              : 'Trouvez ici les réponses aux questions les plus courantes sur El Hiba Para.'}
          </p>
        </div>
      </div>

      <div className="faq-list">
        {items.map((item, index) => (
          <div key={item.question} className={`faq-item ${openIndex === index ? 'open' : ''}`}>
            <button
              className="faq-question"
              onClick={() => toggleItem(index)}
              aria-expanded={openIndex === index}
            >
              <span>{item.question}</span>
              <i className={`fas fa-chevron-${openIndex === index ? 'up' : 'down'}`}></i>
            </button>
            {openIndex === index && (
              <p className="faq-answer">{item.answer}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const FAQ = () => {
  return (
    <div className="legal-page faq-page">
      <div className="container">
        <div className="faq-page-header">
          <div className="faq-page-icon">
            <i className="fas fa-circle-question"></i>
          </div>
          <h1>Questions Fréquentes</h1>
          <p>Tout ce que vous devez savoir sur El Hiba Para</p>
        </div>

        <div className="faq-columns">
          <FaqColumn lang="fr" items={faqItemsFr} />
          <FaqColumn lang="ar" items={faqItemsAr} />
        </div>
      </div>
    </div>
  );
};

export default FAQ;
